import { Survey } from "@velaro/velaro-component-lib";
import React from "react";

export const SurveysContext = React.createContext<{
  surveys: Survey[];
  setSurveys: (surveys: Survey[]) => void;
  loading: boolean;
}>({
  surveys: [],
  loading: true,
  setSurveys: () => {}
});
